import React, { useId } from 'react';
import { StatusHelpIcon } from '.';
import Tooltip, { TooltipPosition } from 'components/controls/Tooltip';

const TooltipHelpIcon: React.FunctionComponent<{
  content: string;
  position?: TooltipPosition;
}> = ({ content, position }) => {
  const id = useId();
  return (
    <>
      <StatusHelpIcon id={id} />
      <Tooltip targetId={id} position={position ?? 'bottom'} offset={4}>
        {content}
      </Tooltip>
    </>
  );
};

export default TooltipHelpIcon;
